var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfilePicture = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F56B57",
  d: "M28.835 19.64A7.493 7.493 0 1 0 18.238 9.043 7.493 7.493 0 0 0 28.835 19.64M29.05 23c-2.936 3.662-8.548 3.519-11.29-.29-6.26 2.162-10.736 8.105-10.736 15.074 10.52 1.767 20.765 1.882 31.888 0 .657-6.637-3.782-12.397-9.863-14.784"
})));
export default SvgProfilePicture;